import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  alert,
  float,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { formatNumber } from "../../utils/formatting";

export default class Suppliers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_category: "",
      filter_status: "",

      count: 0,
      page: 1,
      page_size: 10,
      data: [],
      data_supplier: [],
      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,
      modal_detail: false, // เพิ่ม state สำหรับ Modal ดูรายละเอียด
      uid: "",
      supplier_detail: null, // เก็บข้อมูลผู้จำหน่ายที่เลือกดู

      // Form States (for Modal "เพิ่ม/แก้ไขผู้จำหน่าย")
      company_id: company?.id || "",
      form_supplier_code: "",
      form_supplier_name: "",
      form_description: "",
      form_category: "Parts",
      form_contact_person: "",
      form_phone: "",
      form_email: "",
      form_fax: "",
      form_website: "",
      form_address: "",
      form_province: "",
      form_district: "",
      form_sub_district: "",
      form_zip_code: "",
      form_country: "Thailand",
      form_tax_number: "",
      form_payment_terms: "Net 30",
      form_credit_limit: "0.00",
      form_rating: 5.0,
      form_notes: "",
      form_bank_name: "",
      form_bank_account: "",
      form_bank_branch: "",
      is_active: "Active",

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search, filter_category, filter_status, page_size } =
      this.state;
    loading(true);

    let [result, result_supplier] = await Promise.all([
      GET("warehouse/suppliers", {
        page_size: page_size,
        page: page,
        data_search: filter_search || "",
        category_name: filter_category || "",
        is_active: this.state.filter_status || "",
      }),
      GET("warehouse/suppliers", {
        page_size: 100000,
        page: 0,
        data_search: filter_search || "",
        category_name: filter_category || "",
        is_active: this.state.filter_status || "",
      }),
    ]);

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page: page,
      });
    }
    if (result_supplier?.status) {
      this.setState({
        data_supplier: result_supplier.data || [],
      });
    }
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      form_supplier_code,
      form_supplier_name,
      form_description,
      form_category,
      form_contact_person,
      form_email,
      form_phone,
      form_fax,
      form_website,
      form_address,
      form_province,
      form_district,
      form_sub_district,
      form_zip_code,
      form_country,
      form_tax_number,
      form_payment_terms,
      form_credit_limit,
      form_rating,
      form_notes,
      form_bank_name,
      form_bank_account,
      form_bank_branch,
      form_status,
      is_active,
    } = this.state;

    // Validation
    if (!form_supplier_code.trim()) {
      alert("", "warning", t("warning"), t("please_enter_supplier_code"));
      return;
    } else if (!form_supplier_name.trim()) {
      alert("", "warning", t("warning"), t("please_enter_supplier_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);

      let body = {
        company_id: company_id,
        supplier_code: form_supplier_code,
        name: form_supplier_name,
        description: form_description,
        category_name: form_category,
        contact_person: form_contact_person,
        email: form_email,
        phone: form_phone,
        fax: form_fax,
        website: form_website,
        address: form_address,
        province: form_province,
        district: form_district,
        sub_district: form_sub_district,
        zip_code: form_zip_code,
        country: form_country,
        tax_number: form_tax_number,
        payment_terms: form_payment_terms,
        credit_limit: parseFloat(form_credit_limit) || 0.0,
        rating: parseFloat(form_rating) || 5.0,
        notes: form_notes,
        bank_name: form_bank_name,
        bank_account: form_bank_account,
        bank_branch: form_bank_branch,
        status: form_status,
        is_active: is_active === "Active",
      };

      let result = !uid
        ? await POST("warehouse/suppliers", body)
        : await PUT("warehouse/suppliers/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false });
        this.resetForm();
        this.Get(1); // Refresh data
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/suppliers/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Edit = (item) => {
    this.setState({
      modal_create: true,
      uid: item.uid,
      company_id: item.company_id || company?.id || "",
      form_supplier_code: item.supplier_code || "",
      form_supplier_name: item.name || "",
      form_description: item.description || "",
      form_category: item.category_name || "Parts",
      form_contact_person: item.contact_person || "",
      form_phone: item.phone || "",
      form_email: item.email || "",
      form_fax: item.fax || "",
      form_website: item.website || "",
      form_address: item.address || "",
      form_province: item.province || "",
      form_district: item.district || "",
      form_sub_district: item.sub_district || "",
      form_zip_code: item.zip_code || "",
      form_country: item.country || "Thailand",
      form_tax_number: item.tax_number || "",
      form_payment_terms: item.payment_terms || "Net 30",
      form_credit_limit: item.credit_limit
        ? item.credit_limit.toString()
        : "0.00",
      form_rating: item.rating || 5.0,
      form_notes: item.notes || "",
      form_bank_name: item.bank_name || "",
      form_bank_account: item.bank_account || "",
      form_bank_branch: item.bank_branch || "",
      form_status: item.status || "Active",
      is_active: item.is_active === false ? "Inactive" : "Active",
    });
  };

  // ฟังก์ชันเปิด Modal ดูรายละเอียด
  openDetail = (item) => {
    this.setState({
      modal_detail: true,
      supplier_detail: item,
    });
  };

  resetForm = () => {
    this.setState({
      uid: "",
      form_supplier_code: "",
      form_supplier_name: "",
      form_description: "",
      form_category: "Parts",
      form_contact_person: "",
      form_phone: "",
      form_email: "",
      form_fax: "",
      form_website: "",
      form_address: "",
      form_province: "",
      form_district: "",
      form_sub_district: "",
      form_zip_code: "",
      form_country: "Thailand",
      form_tax_number: "",
      form_payment_terms: "",
      form_credit_limit: "0.00",
      form_rating: 5.0,
      form_notes: "",
      form_bank_name: "",
      form_bank_account: "",
      form_bank_branch: "",
      form_status: "Active",
      is_active: "Active",
    });
  };

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };

  getInitials = (name) => {
    if (!name) return "NA";
    return name.substring(0, 2).toUpperCase();
  };

  getCategoryColor = (category) => {
    if (category === "Parts") return "primary";
    if (category === "Equipment") return "purple";
    if (category === "Consumables") return "warning";
    return "secondary";
  };

  render() {
    const {
        data,
        data_supplier,
        count,
        filter_search,
        filter_category,
        filter_status,
        modal_create,
        modal_detail,
        supplier_detail,
        form_supplier_code,
        form_category,
        form_supplier_name,
        form_address,
        form_contact_person,
        form_phone,
        form_email,
        form_fax,
        form_payment_terms,
        form_credit_limit,
        form_tax_number,
        form_bank_name,
        form_rating,
        form_bank_account,
        form_bank_branch,
        is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("suppliers")}</h3>
                    <div className="text-secondary text-14">{t("manage_suppliers_desc")}</div>
                </div>

                {/* Top Stats Cards (4 Columns) */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf1ad"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{formatNumber(data_supplier.length)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("total_suppliers")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf005"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{formatNumber(data_supplier?.filter((e) => 4 < Number(e.rating)).length)}</h3>
                                    <div className="text-secondary text-12 fw-bold">
                                        {t("main_suppliers")} {t("rate_4_suppliers")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf571"}</div>
                                <div>
                                    <h3 className="fw-bold text-purple mb-0">{0}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("total_purchase_this_year")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf0d1"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{0}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("on_time_delivery_avg")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex gap-3 flex-wrap flex-grow-1">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_supplier_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "Parts", label: "Parts" },
                                    { value: "Equipment", label: "Equipment" },
                                    { value: "Consumables", label: "Consumables" },
                                ]}
                                value={filter_category}
                                onChange={(e) => this.setState({ filter_category: e })}
                                placeholder={t("all_categories")}
                                defaultLabel={t("all_categories")}
                            />
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_statuses")}
                                defaultLabel={t("all_statuses")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() =>
                                        this.setState(
                                            {
                                                filter_search: "",
                                                filter_category: "",
                                                filter_status: "",
                                            },
                                            () => this.Get(1)
                                        )
                                    }
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {can("supplier.create") && (
                                <button
                                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                                onClick={() => {
                                    this.resetForm();
                                    this.setState({ modal_create: true });
                                }}
                            >
                                <span className="me-2 text-16">+</span> {t("add_supplier")}
                            </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm pb-2">
                    {/* Supplier Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-4 border-0 wpx-250">{t("supplier_name_col")}</th>
                                    <th className="py-3 border-0 wpx-200">{t("contact_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("category_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("part_count_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-150">{t("payment_terms_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("rating_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("status_col")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("manage_col")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, idx) => {
                                        const catColor = this.getCategoryColor(item.category_name);
                                        const statusColor = item.status === "ok" || item.status === "Active" ? "success" : "secondary";

                                        return (
                                            <tr key={idx} className="border-bottom border-light bg-white">
                                                <td className="py-1 px-4">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className={`wpx-35 hpx-35 rounded-3 d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary-light text-primary`}
                                                        >
                                                            {this.getInitials(item.name)}
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-primary text-14 pointer hover-underline text-nowrap">{item.name}</div>
                                                            <div className="text-secondary text-12">{item.supplier_code}</div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="text-dark text-14">{item.contact_person || "-"}</div>
                                                    <div className="text-secondary text-12">{item.phone || "-"}</div>
                                                </td>

                                                <td className="text-center">
                                                    <span className={`badge bg-${catColor}-light text-${catColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${catColor}`}>
                                                        {item.category_name || "-"}
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="fw-bold text-dark text-14">{formatNumber(item.total_items || 0)}</span>
                                                </td>

                                                <td className="text-center">
                                                    <div className="text-secondary text-14">{item.payment_terms || "-"}</div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="d-flex align-items-center justify-content-center text-dark text-14 fw-bold">
                                                        <span className="icon text-warning me-1 text-12">{"\uf005"}</span> {item.rating || 0}
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    {item.is_active ? (
                                                        <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                    ) : (
                                                        <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                    )}
                                                </td>

                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                                        {/* เรียกฟังก์ชัน openDetail เพื่อดูข้อมูล */}
                                                        <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.openDetail(item)} />
                                                        {/* เรียกฟังก์ชัน Edit เพื่อแก้ข้อมูล */}
                                                        {can("supplier.update") && (
                                                            <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.Edit(item)} />
                                                        )}
                                                        {/* ประวัติ PO */}
                                                        {/* <span className="icon pointer hover-danger transition-hover" onClick={() => {}}>
                                                            {"\uf1da"}
                                                        </span> */}
                                                        {/* เรียกฟังก์ชัน Delete เมื่อคลิกถังขยะ */}
                                                        {can("supplier.delete") && (
                                                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item.uid)} />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer Pagination */}
                    <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                        <div>
                            {t("showing")} 1-{data.length} {t("of_total")} {this.formatNumber(count)} {t("suppliers_unit")}
                        </div>
                        <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>
            </div>

            {/* MODAL: เพิ่ม/แก้ไขผู้จำหน่าย */}
            <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{this.state.uid ? t("edit_supplier_title") : t("add_new_supplier_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <h5 className="fw-bold text-dark mb-3">{t("basic_info")}</h5>
                    <div className="row g-3 mb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("supplier_code")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" placeholder="SUP-XXX" value={form_supplier_code} onChange={(e) => this.setState({ form_supplier_code: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("category_col")}</label>
                            <Select
                                className="form-control"
                                options={[
                                    { value: "Parts", label: "Parts" },
                                    { value: "Equipment", label: "Equipment" },
                                    { value: "Consumables", label: "Consumables" },
                                ]}
                                value={form_category}
                                onChange={(e) => this.setState({ form_category: e })}
                                placeholder="Parts"
                                default={false}
                            />
                        </div>
                        <div className="col-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("supplier_name")} <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("supplier_name")}
                                value={form_supplier_name}
                                onChange={(e) => this.setState({ form_supplier_name: e.target.value })}
                            />
                        </div>
                        <div className="col-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("rating")} (0-5 {t("rating")})
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("rating")}
                                value={form_rating}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    if (5 < Number(e.target.value)) {
                                        e.target.value = 5;
                                    }
                                    this.setState({ form_rating: e.target.value });
                                }}
                            />
                        </div>
                        <div className="col-12">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("address")}</label>
                            <textarea className="form-control" rows="3" placeholder={t("address")} value={form_address} onChange={(e) => this.setState({ form_address: e.target.value })}></textarea>
                        </div>
                    </div>
                    <hr />
                    <h5 className="fw-bold text-dark mb-3">{t("contact_info")}</h5>
                    <div className="row g-3 mb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("contact_person")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("contact_person")}
                                value={form_contact_person}
                                onChange={(e) => this.setState({ form_contact_person: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("phone")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="02-XXX-XXXX"
                                maxLength={10}
                                value={form_phone}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    this.setState({ form_phone: e.target.value });
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("email")}</label>
                            <input type="email" className="form-control" placeholder="email@company.com" value={form_email} onChange={(e) => this.setState({ form_email: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("fax")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="02-XXX-XXXX"
                                maxLength={10}
                                value={form_fax}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    this.setState({ form_fax: e.target.value });
                                }}
                            />
                        </div>
                    </div>
                    <hr />
                    <h5 className="fw-bold text-dark mb-3">{t("payment_terms")}</h5>
                    <div className="row g-3 mb-3">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("payment_terms")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Net 30, 5, etc."
                                value={form_payment_terms}
                                onChange={(e) => this.setState({ form_payment_terms: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("credit_limit")}</label>
                            <input type="number" className="form-control" placeholder="0.00" value={form_credit_limit} onChange={(e) => this.setState({ form_credit_limit: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("tax_id")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("tax_id")}
                                value={form_tax_number}
                                maxLength={13}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    this.setState({ form_tax_number: e.target.value });
                                }}
                            />
                        </div>
                        {/* ซ่อน Currency ไว้หรือปรับใช้งานทีหลัง เนื่องจากไม่มีใน API payload */}
                    </div>
                    <hr />
                    <h5 className="fw-bold text-dark mb-3">{t("bank")}</h5>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("bank_name")}</label>
                            <input type="text" className="form-control" placeholder={t("bank_name")} value={form_bank_name} onChange={(e) => this.setState({ form_bank_name: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("bank_account")}</label>
                            <input
                                type="test"
                                className="form-control"
                                placeholder="0000000000000"
                                value={form_bank_account}
                                maxLength={20}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    this.setState({ form_bank_account: e.target.value });
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("bank_branch")}</label>
                            <input type="text" className="form-control" placeholder={t("bank_branch")} value={form_bank_branch} onChange={(e) => this.setState({ form_bank_branch: e.target.value })} />
                        </div>
                        {/* ซ่อน Currency ไว้หรือปรับใช้งานทีหลัง เนื่องจากไม่มีใน API payload */}
                    </div>
                    <hr />

                    {/* Status */}
                    <h6 className="fw-bold mb-1 d-flex align-items-center">
                        <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                    </h6>
                    <div className="d-flex gap-4 mt-3">
                        <div className="form-check d-flex align-items-center gap-2">
                            <input
                                className="form-check-input mt-0 pointer"
                                type="radio"
                                name="uomStatus"
                                id="statusActive"
                                checked={is_active === "Active"}
                                onChange={() => this.setState({ is_active: "Active" })}
                            />
                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                {t("active")}
                            </label>
                        </div>
                        <div className="form-check d-flex align-items-center gap-2">
                            <input
                                className="form-check-input mt-0 pointer"
                                type="radio"
                                name="uomStatus"
                                id="statusInactive"
                                checked={is_active === "Inactive"}
                                onChange={() => this.setState({ is_active: "Inactive" })}
                            />
                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                {t("inactive")}
                            </label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_create: false })}>
                        {t("cancel")}
                    </button>
                    {/* เรียก CreateUpdate เมื่อกดบันทึก */}
                    <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm" onClick={this.CreateUpdate}>
                        {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
            {/* MODAL: ดูรายละเอียดผู้จำหน่าย (อันใหม่) */}
            <Modal size="lg" show={modal_detail} onHide={() => this.setState({ modal_detail: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("supplier_details_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-light">
                    {supplier_detail && (
                        <div className="row g-3">
                            {/* ข้อมูลพื้นฐาน */}
                            <div className="col-12">
                                <div className="bg-white p-4 rounded-4 shadow-sm">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("basic_info")}</h6>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("supplier_code")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.supplier_code || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("category_col")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.category_name || "-"}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("company_supplier_name")}</div>
                                            <div className="fw-bold text-dark text-16">{supplier_detail.name || "-"}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("details_label")}</div>
                                            <div className="text-dark">{supplier_detail.description || "-"}</div>
                                        </div>
                                        <div className="col-12 mt-3">
                                            <div className="text-secondary text-12">{t("label_address")}</div>
                                            <div className="text-dark">
                                                {supplier_detail.address}
                                                {supplier_detail.sub_district ? ` ${t("sub_district_abbr")}${supplier_detail.sub_district}` : ""}
                                                {supplier_detail.district ? ` ${t("district_abbr")}${supplier_detail.district}` : ""}
                                                {supplier_detail.province ? ` ${t("province_abbr")}${supplier_detail.province}` : ""}
                                                {supplier_detail.zip_code ? ` ${supplier_detail.zip_code}` : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ข้อมูลการติดต่อ */}
                            <div className="col-md-6">
                                <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("contact_info")}</h6>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("contact_person")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.contact_person || "-"}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("phone")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.phone || "-"}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("email")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.email || "-"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ข้อมูลการชำระเงินและบัญชี */}
                            <div className="col-md-6">
                                <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("financial_info")}</h6>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("tax_id")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.tax_number || "-"}</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("payment_terms")}</div>
                                            <div className="fw-bold text-dark">{supplier_detail.payment_terms || "-"}</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("credit_limit")}</div>
                                            <div className="fw-bold text-dark">{this.formatNumber(supplier_detail.credit_limit)}</div>
                                        </div>
                                        <div className="col-12 mt-2 pt-2 border-top">
                                            <div className="text-secondary text-12 mb-1">{t("bank_info")}</div>
                                            <div className="text-dark text-14">
                                                {t("bank_name")}: <span className="fw-bold">{supplier_detail.bank_name || "-"}</span>
                                            </div>
                                            <div className="text-dark text-14">
                                                {t("bank_branch")}: <span className="fw-bold">{supplier_detail.bank_branch || "-"}</span>
                                            </div>
                                            <div className="text-dark text-14">
                                                {t("bank_account")}: <span className="fw-bold">{supplier_detail.bank_account || "-"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end">
                    <button className="btn btn-secondary px-4 py-2 text-white rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_detail: false })}>
                        {t("close")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
